module.exports = __webpack_public_path__ + "static/img/6.95017389.png";